// services/frontend/src/components/signup/SignupTextInput.jsx
import React from 'react';

/**
 * [Why]
 * 회원가입 화면에서 입력 필드 스타일/에러 메시지 표시 규칙을 통일하기 위한 컴포넌트입니다.
 *
 * [How]
 * - input 자체는 HTML input을 그대로 사용하되, 공통 스타일을 적용합니다.
 * - errorText가 있으면 하단에 안내 문구를 렌더링합니다.
 */
export default function SignupTextInput({
  type = 'text',
  value,
  onChange,
  onBlur,
  onFocus,
  placeholder,
  autoComplete,
  readOnly,
  disabled,
  errorText,
  helperText,
}) {
  // [회원가입 UX]
  // - 주소/우편번호처럼 사용자가 직접 수정하면 안 되는 필드는 readOnly로 잠그되,
  //   비활성 입력처럼 보이도록 시각적 톤(배경/글자색)을 조정합니다.
  // - disabled는 포커스/복사까지 막을 수 있어 화면별 요구사항에 따라 readOnly를 주로 사용합니다.
  const isInactiveLike = !!disabled || !!readOnly;

  return (
    <div style={{ display: 'grid', gap: 6 }}>
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        autoComplete={autoComplete}
        readOnly={readOnly}
        disabled={disabled}
        style={{
          height: 44,
          padding: '10px 12px',
          borderRadius: 10,
          border: '1px solid #e5e7eb',
          fontSize: 16,
          outline: 'none',
          background: isInactiveLike ? '#f3f4f6' : '#fff',
          color: isInactiveLike ? '#9ca3af' : '#111827',
        }}
      />
      {errorText ? (
        <div style={{ color: '#b91c1c', fontSize: 13 }}>{errorText}</div>
      ) : helperText ? (
        <div style={{ color: '#6b7280', fontSize: 13 }}>{helperText}</div>
      ) : null}
    </div>
  );
}
